import { all, takeLatest, call, put, select } from 'redux-saga/effects'
import UserNotificationActions from 'modules/domain/userNotifications/duck'
import * as managers from './managers'
import UserNotificationSelectors from './selectors'
import { UserNotification } from 'modules/domain/userNotifications/types'
import { ListResponse } from 'types/api'
import { RequestError } from 'modules/errors'

export const fetchList = function* () {
  try {
    let currentPage = yield select(UserNotificationSelectors.page)
    const filter = yield select(UserNotificationSelectors.filter)
    const sorting = yield select(UserNotificationSelectors.sorting)
    const pageSize = yield select(UserNotificationSelectors.pageSize)

    let response: ListResponse<UserNotification> = yield call(
      managers.getUserNotificationsList,
      filter,
      sorting,
      currentPage,
      pageSize,
    )
    const pages = Math.ceil(response.total_count / pageSize)
    if (pages !== 0 && pages < currentPage) {
      response = yield call(managers.getUserNotificationsList, filter, sorting, pages, pageSize)
      currentPage = pages
    }

    const { data, page, total_count } = response
    yield put(UserNotificationActions.listRequestSucceed(data, total_count, page))
  } catch (err) {
    const errType = err instanceof RequestError ? err.type : 'unknown'
    yield put(UserNotificationActions.listRequestFailed(errType))
  }
}

export const fetchUserNotification = function* ({
  payload: id,
}: ReturnType<typeof UserNotificationActions.itemRequested>) {
  try {
    const notification: UserNotification = yield call(managers.getUserNotification, id)
    yield put(UserNotificationActions.itemRequestSucceed(notification))
  } catch (err) {
    const errType = err instanceof RequestError ? err.type : 'unknown'
    yield put(UserNotificationActions.itemRequestFailed(id, errType))
  }
}

export const dismissNotification = function* ({
  payload: id,
}: ReturnType<typeof UserNotificationActions.dismissRequested>) {
  try {
    yield call(managers.dismissUserNotification, id)
    yield put(UserNotificationActions.dismissSucceed(id))
    // Optionally refresh the list after dismissing
    yield put(UserNotificationActions.listRequested({}))
  } catch (err) {
    const errType = err instanceof RequestError ? err.type : 'unknown'
    yield put(UserNotificationActions.dismissFailed(id, errType))
  }
}

const UserNotificationsSaga = function* () {
  yield all([
    takeLatest(UserNotificationActions.itemRequested.type, fetchUserNotification),
    takeLatest(UserNotificationActions.listRequested.type, fetchList),
    takeLatest(UserNotificationActions.filterUpdated.type, fetchList),
    takeLatest(UserNotificationActions.sortingUpdated.type, fetchList),
    takeLatest(UserNotificationActions.filterHasBeenReset.type, fetchList),
    takeLatest(UserNotificationActions.sortingHasBeenReset.type, fetchList),
    takeLatest(UserNotificationActions.dismissRequested.type, dismissNotification),
  ])
}

export default UserNotificationsSaga
